module.exports = __webpack_public_path__ + "img/pi-4-4.520e5bcc.jpg";